<template>
  <div>
    <div class="totalSumBlock flex justify-content-between">
      <div>
        <strong v-if="invoice.status === 7">Приемка в процессе</strong>
      </div>
      <div class="text-right" v-html="totalFigures()"/>
    </div>
    <table class="table table-sm table-hover mt-1">
      <thead>
      <tr class="sticky_tr">
        <th width="50px"></th>
        <th width="50px">№</th>
        <th width="50px"></th>
        <th v-if="invoiceType === 'income'" width="50px">Другая валюта</th>
        <th class="flex align-items-center">
          <div class="sorting_block">
            <dropdown-menu
              v-model="showSortingDropDown"
              :interactive="true"
              :closeOnClickOutside="true"
            >
              <button class="btn btn-default mr-2">сортировка</button>
              <div slot="dropdown">
                <a @click.prevent="updateSort('enAlph')" class="dropdown-item pointer">По EN алфавиту</a>
                <a @click.prevent="updateSort('ruAlph')" class="dropdown-item pointer">По алфавиту</a>
                <a @click.prevent="updateSort('created')" class="dropdown-item pointer">По добавлению</a>
              </div>
            </dropdown-menu>
          </div>
          Препарат
        </th>
        <th width="150px" v-if="showExpireDates || editExpireDates">Сроки годности</th>
        <th v-if="moderateQty"></th>
        <th>Кол{{ transitInvoice ? '' : ' заказ' }}</th>
        <template v-if="editQtyByFact">
          <th>Факт. кол.</th>
          <th>Остаток</th>
        </template>
        <th>{{ !editPrices ? 'Себестоимость' : 'Стоимость' }}</th>
        <th>Сумма</th>
        <template v-if="showDiscount">
          <th>Стоимость со скидкой</th>
          <th>Сумма со скидкой</th>
        </template>
        <template v-if="showExpensesPrice">
          <th>Стоимость с расходами</th>
          <th>Сумма</th>
        </template>
        <th v-if="showIntermediateSum"></th>
        <th v-if="showRemainStore">Остаток</th>
        <th v-if="displayDetails?.showExpiresDatesBefore?.show">Сроки годности</th>
      </tr>
      </thead>
      <tbody>
      <!--      <template v-for="(detail, index) in detailList.filter((d) => !d.toDelete && !d.searchHide)"">-->
      <template v-for="(detail, index) in getFilteredRecords()">
        <tr v-if="!detail.toDelete && !detail.searchHide"
            :class="{
            bg_success: hasDetailByAlias((detail?.drug?.details ?? []), 'orderRates'),
            mark: detail.selected,
            no_en_title: invoice.type === 4 && detail.drug?.id && !detail.drug.en_title,
            storeMissing:  isStoreMiss(detail)
          }">
          <td><p class="table_p"><input class="w_50p" type="checkbox" v-model="detail.selected"></p></td>
          <td><p class="table_p">{{ index + 1 }}</p></td>
          <td>
            <template v-if="detail.drug">
              <DetailCommentBlock
                :invoice="invoice"
                :detail="detail"
                :updateRecord="(r) => detailList[index] = {...detailList[index], ...r}"
              />
            </template>
          </td>
          <td v-if="invoiceType === 'income'">
            <p class="table_p"><input class="w_50p" type="checkbox" v-model="detail.anyCurrency"></p>
          </td>
          <td>
            <template v-if="disableEdit && !allowToEdit[detail?.drug?.id]">
              <div class="input-group">
                <input :value="detail?.drug?.title" disabled type="text" class="form-control">
                <div class="input-group-append">
                  <button @click="updateAllowEdit(detail?.drug?.id)" class="btn btn-sm btn-info"><i
                    class="icon-fa icon-fa-edit"/>
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <DrugSearchNew
                :ref="`search_drug_${index}`"
                :selectedDrug="detail.drug"
                :searchOptions="{currencyId: invoiceType === 'income' ? !detail.anyCurrency ? invoice.currency_id : false : false}"
                :onSelect="(d) => addDrug(index, detail?.drug?.id, d)"
              />
            </template>
            <div>

              <p v-if="detail?.drug?.id">ENG: {{ getEnTitle(detail.drug) }}</p>
              <DetailsView :drug="detail?.drug" :details="detail?.drug?.details ?? []"/>

              <div v-if="(detail.extra_data?.selected_expire_dates ?? []).length">
                <i>Указаны сроки годности:</i>
                <strong><span
                  v-for="(d,i) in detail.extra_data.selected_expire_dates">{{ i !== 0 ? ', ' : '' }}{{ d.date }}</span></strong>
              </div>
            </div>
          </td>
          <td v-if="showExpireDates || editExpireDates">
            <ExpireDatesByMask
              :allToSelectDate="true"
              :disableEdit="true"
              :invoiceId="invoice.id"
              :updateDates="(d) => {}"
              :drug-id="detail.drug_id"
              :savedDates="getSavedExpireDates(detail)"
              :expireDates="drugExpireDates[detail.drug_id]"/>
            <!--            <p v-for="d in (detail.extra_data?.expire_dates ?? []).filter((e) => e)">{{ d }}</p>-->
          </td>
          <td v-if="moderateQty">
            <template v-if="detail.drug?.id && detail.income_qty !== null && detail.qty !== detail.income_qty">
              <div class="input-group moderate_qty">
                <input type="text" v-model="detail.income_qty" disabled class="form-control">
                <div class="input-group-append flex">
                  <button class="btn btn-outline-success" @click="updateIncomeQty(detail)" type="button">
                    <i class="icon-fa icon-fa-check"/>
                  </button>
                  <button class="btn btn-outline-danger" @click="updateIncomeQty(detail, true)" type="button">
                    <i class="icon-fa icon-fa-close"/>
                  </button>
                </div>
              </div>
            </template>
          </td>
          <td><input :disabled="(disableEdit || editQtyByFact) && !allowToEdit[detail?.drug?.id]"
                     type="number"
                     v-model="detail.qty"
                     class="form-control"></td>
          <template v-if="editQtyByFact">
            <td>
              <template v-if="detail?.drug?.detail">
                <v-popover
                  :auto-hide="true"
                  placement="bottom"
                  @hide="() => confirmRateTooltip[detail.id] = false"
                  :open="confirmRateTooltip[detail.drug.id]"
                >
                  <input @keyup="(event) => shiftFocus(event, index, detail.drug.id)"
                         @change="updateRemainQty(detail.drug.id)"
                         type="number"
                         v-model="detail.income_qty"
                         class="form-control qty_by_fact">
                  <template slot="popover">
                    <p>Препарат заказывается по коэффициенту</p>
                    <p>Выберите количество</p>
                    <div class="flex">
                      <button @click="confirmRateTooltip[detail.id] = false" class="btn btn-default">{{
                          detail.income_qty
                        }}
                      </button>
                      <button
                        @click="detail.income_qty = detail.income_qty * +detail.drug.detail.int_value;confirmRateTooltip[detail.id] = false"
                        class="btn btn-default ml-2">{{ detail.income_qty * +detail.drug.detail.int_value }}
                      </button>
                    </div>
                  </template>
                </v-popover>
              </template>
              <template v-else>
                <input @keyup="(event) => shiftFocus(event, index)" @change="updateRemainQty(detail.drug.id)"
                       type="number"
                       v-model="detail.income_qty"
                       class="form-control qty_by_fact">
              </template>
            </td>
            <td><input type="number" v-model="detail.remain_qty" class="form-control"></td>
          </template>
          <td>
            <template v-if="editPrices">
              <input @change="() => getRecords(false)" type="number"
                     :disabled="disableEdit && !allowToEdit[detail?.drug?.id]"
                     v-model="detail.income_price"
                     class="form-control">
            </template>
            <template v-else>
              <input type="number" disabled v-model="detail.cost_price" class="form-control">
            </template>
          </td>
          <td>
            <p class="table_p">{{
                Math.round(+detail.qty * (transitInvoice ? +detail.cost_price : +detail.income_price) * 1000) / 1000
              }}</p>
          </td>
          <template v-if="showDiscount">
            <td><p class="table_p">{{ detail.price || 0 }}</p></td>
            <td><p class="table_p">{{ Math.round((detail.price || 0) * (+detail.qty || 0) * 1000) / 1000 }}</p></td>
          </template>
          <template v-if="showExpensesPrice">
            <td><p class="table_p">{{ (detail.price_w_expense || 0) }}</p></td>
            <td><p class="table_p">{{
                Math.round((detail.price_w_expense || 0) * (+detail.qty || 0) * 1000) / 1000
              }}</p>
            </td>
          </template>
          <td v-if="showIntermediateSum"><p class="table_p">{{ getIntermSumByIndex(index) }}</p></td>
          <td v-if="showRemainStore">
            <p class="table_p">
              {{
                detail?.drug?.id && storeRemain[detail.drug.id] && storeRemain[detail.drug.id][invoice.store_out]
              }}</p>
          </td>
          <td class="pl-2" v-if="displayDetails?.showExpiresDatesBefore?.show">
            <p v-for="d in sortArray((detail.drug?.valid_dates ?? []), 'expire_date')" v-if="d.is_active">
              {{ printDate(d.expire_date, 'DD.MM.YYYY') }}</p>
          </td>
        </tr>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import DetailCommentBlock from "@/views/admin/invoices/components/DetailCommentBlock";
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import DropdownMenu from '@innologica/vue-dropdown-menu'
import api from "@/api";
import VTooltip from 'v-tooltip'
import DetailsView from "@/components/drugs/DetailsView.vue";
import moment from "moment/moment";
import ExpireDatesByMask from "@/components/drugs/ExpireDatesByMask.vue";

export default {
  props: ['records', 'showExpireDates', 'editExpireDates', 'displayDetails', 'selectCostPrice', 'invoice', 'updateRecords', 'storeData', 'editQtyByFact', 'searchDrugText', 'selectSearchField'],
  components: {
    ExpireDatesByMask,
    DetailsView,
    DetailCommentBlock,
    DrugSearchNew,
    DropdownMenu,
    VTooltip,
  },
  data() {
    return {
      drugExpireDates: {},
      moderateQty: false,
      showRemainStore: false,
      invoiceType: 'income',
      allowToEdit: {},
      confirmRateTooltip: {},
      disableEdit: false,
      transitInvoice: false,
      editPrices: false,
      loadingCostPrice: {},
      costPriceData: {},
      showSortingDropDown: false,
      sortingField: 'enAlph',
      detailList: [],
      totalData: {
        drugs: 0,
        sum: 0
      },
      showIntermediateSum: true,
      showDiscount: false,
      showExpensesPrice: false,
      storeRemain: {},
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    }
  },
  watch: {
    'searchDrugText': {
      handler: function (val, oldVal) {
        // this.updatePullOfDrugs();
        this.detailList = this.detailList.map((d) => {
          return {...d, searchHide: false}
        });
        if (this.searchDrugText) {
          const searchText = this.searchDrugText.toLowerCase();
          this.detailList = this.detailList.map((r) => {
            return {
              ...r,
              searchHide: !(r.drug?.id &&
                (r.drug.en_title.toLowerCase().includes(searchText)
                  || r.drug.title.toLowerCase().includes(searchText)
                ))
            };
          });
          // } else {
          //   this.getRecords();
        }
      },
      deep: true
    },
    'invoice': {
      handler: function (val, oldVal) {
        this.getRecords();
      },
      deep: true
    },
  },
  created() {
    this.updatePullOfDrugs();

    this.editPrices = ![2, 3].includes(+this.invoice.type);
    this.transitInvoice = [2, 3].includes(+this.invoice.type);
    this.disableEdit = this.invoice.status === 0;
    this.invoiceType = this.transitInvoice ? 'transit' : 'income';
    if (+this.invoice.type === 3) this.invoiceType = 'writeOff';
    this.showRemainStore = this.invoiceType === 'writeOff' || this.invoiceType === 'transit';
    if (this.storeData) {
      this.storeRemain = {...this.storeData};
    }
    if (!this.invoice.extra_settings) this.invoice.extra_settings = {};
    if (!this.invoice.extra_settings?.drugSorting) this.invoice.extra_settings.drugSorting = this.sortingField;
    this.sortingField = this.invoice.extra_settings.drugSorting;

    this.moderateQty = this.invoice.status === 3;

    if (this.selectCostPrice) this.editPrices = true;

    this.getRecords();
    this.addEmptyRow();
    this.updateSort();
  },
  methods: {
    getSavedExpireDates(detail) {
      return (detail.extra_data?.expire_dates ?? []).reduce((acc, r) => {
        acc[r] = true;
        return acc;
      }, {});
    },
    getFilteredRecords() {
      if (this.displayDetails?.showExpiresDatesBefore?.show) {
        const regex = /^(0[1-9]|1[0-2])\.\d{4}$/;
        if (!regex.test(this.displayDetails?.showExpiresDatesBefore?.date)) return [];
        return this.detailList.filter((r) => {
          return !(r.drug?.valid_dates ?? []).length || !!(r.drug?.valid_dates ?? []).find((d) => d.is_active && moment(d.expire_date).isBefore(moment(this.displayDetails.showExpiresDatesBefore.date, 'MM.YYYY')));
        });
      }
      return this.detailList;
    },
    getEnTitle(drug) {
      const details = drug.details ?? [];
      if (this.invoiceType !== 'income') return drug?.en_title ?? '';
      let det = details.find((d) => d.text_value && d.group_alias === 'supplier' && d.alias === "supplier_title" && d.int_value === this.invoice.supplier_id);
      if (det) return det.text_value;
      det = details.find((d) => d.text_value && d.group_alias === 'supplier' && d.alias === "country_title" && d.int_value === this.invoice.country_id);
      if (det) return det.text_value;
      return drug?.en_title ?? '';
    },
    hasDetailByAlias(details, alias) {
      switch (alias) {
        case 'orderRates':
          return !!details.find((d) => ['oposit_order_rate', 'order_rate'].includes(d.alias) && +d.int_value && +d.int_value !== 1);
        default:
          return false
      }
    },
    async updateIncomeQty(detail, cancelQty = false) {
      const index = this.records.findIndex((d) => d.drug_id === detail.drug_id);
      console.log(index);
      if (cancelQty) {
        this.records[index].income_qty = null;
      } else {
        this.records[index].qty = this.records[index].income_qty;
      }
      if (this.updateRecords) this.updateRecords([...this.records])
      this.updatePullOfDrugs();
      this.getRecords();
    },
    isStoreMiss(detail) {
      if (this.invoice.status === 0) return false;
      if (this.invoiceType === 'writeOff' || this.invoiceType === 'transit') {
        if (detail?.drug?.id) {
          if (detail?.qty && this.storeRemain[detail.drug.id]) {
            return detail.qty > (this.storeRemain[detail.drug.id][this.invoice.store_out] || 0);
          }
        }
      }
      return false;
    },
    updatePullOfDrugs() {
      this.detailList = (this.records || []).reduce((acc, r) => {
        if (r.qty % 1 === 0) r.qty = +r.qty;
        if (r.income_qty === null) {
          r.income_qty = r.qty;
        }
        if (r.income_qty % 1 === 0) r.income_qty = +r.income_qty;
        if (r.remain_qty % 1 === 0) r.remain_qty = +r.remain_qty;
        r.income_price = Math.round((+r.income_price || +r.price) * 1000) / 1000;
        r.price_w_expense = 0;
        if (+r.qty) {
          acc.push({...r, selected: false, toDelete: false});
          // return {...r, selected: false, toDelete: false};
        }
        return acc;
      }, []);
    },
    updateAllowEdit(drugId) {
      this.allowToEdit[drugId] = true;
      this.allowToEdit = {...this.allowToEdit};
    },
    updateSort(type = null) {
      if (type) this.sortingField = type;
      this.invoice.extra_settings.drugSorting = this.sortingField;
      switch (this.sortingField) {
        case 'enAlph':
          this.detailList = _.orderBy(this.detailList, 'drug.en_title')
          break;
        case 'ruAlph':
          this.detailList = _.orderBy(this.detailList, 'drug.title')
          break;
        case 'created':
          this.detailList = _.orderBy(this.detailList, 'id')
          break;
      }
      this.showSortingDropDown = false;
    },
    getIntermSumByIndex(index) {
      return Math.round(this.detailList.filter((d) => !d.toDelete).reduce((acc, d, i) => {
        if (index >= i) {
          if (this.showExpensesPrice) {
            acc += (+d.qty || 0) * (+d.price_w_expense || 0);
          } else if (this.showDiscount) {
            acc += (+d.qty || 0) * (+d.price || 0);
          } else {
            acc += (+d.qty || 0) * ((this.transitInvoice ? +d.cost_price : +d.income_price) || 0);
          }
        }
        return acc;
      }, 0) * 1000) / 1000;
    },
    getPriceWithExpanses(d, sum = false) {
      // console.log(d);
      const totalQty = this.detailList.reduce((acc, d) => acc + +d.qty, 0);
      const rate = +this.invoice.extra_expenses / totalQty;
      const price = Math.round((d.price + (rate * +d.qty)) * 1000) / 1000;
      return sum ? price * +d.qty : price;
    },
    addEmptyRow() {
      this.detailList = this.detailList.filter((d) => d.drug.id);
      this.detailList.push({drug: {}, qty: 0, income_price: 0, cost_price: 0, selected: false, toDelete: false});
    },
    shiftFocus(e, index, drugId = null) {
      if (drugId) {
        this.confirmRateTooltip[drugId] = true;
        this.confirmRateTooltip = {...this.confirmRateTooltip};
      }
      if (e.key === 'Enter' && this.selectSearchField) {
        const inputs = document.querySelectorAll('.form-control.qty_by_fact');
        if (inputs.length > (index + 1)) {
          inputs[index + 1].select();
        } else {
          this.selectSearchField();
        }
      }
    },
    updateRemainQty(drugId) {
      const index = this.detailList.findIndex((d) => d.drug?.id === drugId);
      if (index !== -1) {
        this.detailList[index].remain_qty = Math.round((+this.detailList[index].qty - +this.detailList[index].income_qty) * 100) / 100;
        // if (this.detailList[index])
      }
    },
    totalFigures() {
      const details = this.detailList.filter((d) => !d.toDelete);
      let text = `<p>(<strong>${details.reduce((acc, r) => acc + (+r.qty || 0), 0)} </strong>зав.уп.)`;
      text += ` на сумму <strong>${Math.round(details.reduce((acc, r) => {
        let price = +(this.transitInvoice ? +r.cost_price : +r.income_price);
        if (+this.invoice.type === 3) price = +r.cost_price;
        acc += (+r.qty || 0) * (+price || 0)
        return acc;
      }, 0) * 1000) / 1000}</strong>`;
      if (this.invoice.discount) {
        text += ` сумма со скидкой <strong>${Math.round(details.reduce((acc, r) => acc + ((+r.qty || 0) * (+r.price || 0)), 0) * 1000) / 1000}</strong>`;
      }
      if (this.showExpensesPrice) {
        const total = details.reduce((acc, r) => {
          if (!r.drug?.id) return acc;
          const price = this.showDiscount ? r.price : r.income_price;
          acc += (+r.qty || 0) * +price;
          return acc;
        }, 0);
        text += ` сумма с расходами <strong>${Math.round((total + +(this.invoice.extra_settings?.expenses_by_qty || 0) + +(this.invoice.extra_settings?.expenses_by_price || 0)) * 1000) / 1000}</strong>`;
      }
      if (this.editQtyByFact) {
        text += ` поступление по факту на сумму (<strong>${Math.round(details.reduce((acc, r) => {
            let price = +r.income_price;
            if (this.invoice.discount) price = +r.price;
            if (this.showExpensesPrice) price = +r.price_w_expense;
            acc += ((+r.income_qty || 0) * price)
            return acc;
          }, 0
        ) * 1000) / 1000}</strong>)`;
      }
      return text;
    },
    getTotal(type) {
      const details = this.detailList.filter((d) => !d.toDelete);
      if (type === 'sum') {
        if (this.showDiscount && this.showExpensesPrice || this.showExpensesPrice) {
          return Math.round(details.reduce((acc, r) => acc + ((+r.qty || 0) * r.price_w_expense), 0) * 1000) / 1000;
        }
        if (this.showDiscount) {
          return Math.round(details.reduce((acc, r) => acc + ((+r.qty || 0) * r.price), 0) * 1000) / 1000;
        }
        return Math.round(details.reduce((acc, r) => acc + ((+r.qty || 0) * (this.transitInvoice ? +r.cost_price : +r.income_price)), 0) * 1000) / 1000;
      }
      if (type === 'drugs') return details.reduce((acc, r) => acc + (+r.qty || 0), 0);
    },
    async getRecords(sort = true) {
      this.showDiscount = +this.invoice.discount ? true : false;
      this.showExpensesPrice = +this.invoice.extra_settings.expenses_by_qty || +this.invoice.extra_settings.expenses_by_price;

      this.detailList = this.detailList.map((r) => {
        if (r.income_qty === null) r.income_qty = r.qty;
        if (r.remain_qty === null) r.remain_qty = 0;
        if (this.selectCostPrice) r.cost_price = r.income_price;
        return {...r}
      });

      let percent;
      if (+this.invoice.discount_type === 1) {
        percent = +this.invoice.discount || 0;
      } else {
        const totalSum = this.detailList.reduce((acc, r) => acc + (r.qty * r.income_price), 0);
        percent = Math.round((+this.invoice.discount || 0) * 100 / totalSum * 10) / 10;
      }
      this.detailList = this.detailList.reduce((acc, r) => {
        const price = +r.income_price || +r.price;
        r.price = Math.round((price - (price * percent / 100)) * 1000) / 1000;
        if (r.income_qty === null) r.income_qty = r.qty;
        if (r.remain_qty === null) r.remain_qty = 0;
        acc.push({...r});
        return acc;
      }, []);

      const totalSum = this.detailList.reduce((acc, d) => {
        if (+d.qty) {
          acc += (+d.qty * +(this.showDiscount ? d.price : d.income_price));
        }
        return acc;
      }, 0);

      const totalQty = this.detailList.reduce((acc, d) => acc + +d.qty, 0);

      this.detailList = this.detailList.map((r) => {
        let priceWExp = 0;
        if (this.showExpensesPrice) {
          let rate = 0;
          if (this.invoice.extra_settings?.expenses_by_price) {
            rate += (this.showDiscount ? +r.price : +r.income_price) / totalSum * +this.invoice.extra_settings.expenses_by_price;
          }
          if (this.invoice.extra_settings?.expenses_by_qty) {
            rate += +this.invoice.extra_settings.expenses_by_qty / totalQty;
          }
          if (!this.showDiscount) {
            priceWExp = Math.round((+r.income_price + rate) * 1000) / 1000
          } else {
            priceWExp = Math.round((+r.price + rate) * 1000) / 1000
          }
        }
        return {
          ...r,
          price_w_expense: (+r.qty && +r.income_price) ? priceWExp : 0
        }
      });

      this.drugExpireDates = this.detailList.reduce((acc, d) => {
        acc[d.drug_id] = _.orderBy((d.drug?.valid_dates ?? []).filter((r) => r.is_active || (!r.is_active && r.status === 2)).map((r) => {
          return {...r, date: moment(r.expire_date).format('MM.YYYY'), timestamp: moment(r.expire_date).unix()}
        }), 'timestamp');
        return acc;
      }, {});

      if (sort) {
        this.updateSort();
      }
      return true;
    },
    async getCostPrice(drug) {
      this.loadingCostPrice[drug.id] = true;
      this.loadingCostPrice = {...this.loadingCostPrice};
      const requestType = ['costPrice'];
      requestType.push('storeRemain');
      const {data} = await api.post('/new/drugs/infoType', {
        drug_id: drug.id,
        supplier_id: this.invoice.supplier_id,
        types: requestType,
      })
      if (data.success) {
        this.costPriceData[drug.id] = data;
        this.costPriceData = {...this.costPriceData}
        if (data.storeRemain) {
          this.storeRemain[drug.id] = data.storeRemain;
        }
        // if (this.transitInvoice || +this.invoice.type === 1) {
        const index = this.detailList.findIndex((d) => d.drug.id === drug.id);
        if (index !== -1) {
          if (this.transitInvoice) {
            this.detailList[index].cost_price = +data.cost_price;
          } else {
            let price = +data.income_price * (this.$AllCurrencies[data.currency_id]?.rate ?? 1);
            price = Math.round(price / this.$AllCurrencies[this.invoice.currency_id].rate * 1000) / 1000;
            this.detailList[index].income_price = price;
          }
        }
        // }
      }
      this.loadingCostPrice[drug.id] = false;
    },
    addDrug(i, drugId, drug) {
      // console.log(i, drugId, drug);
      if (!drug) {
        const index = this.detailList.findIndex((d) => d.drug_id === drugId);
        this.detailList[index].toDelete = true;
        if (!this.detailList[index].id) {
          this.detailList = this.detailList.filter((d) => d.drug_id !== drugId);
        } else {
          this.detailList = [...this.detailList];
        }
        this.addEmptyRow();
        return;
      }
      const doubleCheck = this.detailList.find((d) => d && d.drug && d.drug.id === drug.id)
      if (doubleCheck) {
        toastr["warning"]("Препарат уже есть в списке");
        const ref = `search_drug_${i}`
        this.$refs[ref][0].drug = null;
        const index = this.detailList.findIndex((d) => d.drug.id === drugId);
        this.detailList[index].toDelete = true;
        this.detailList = [...this.detailList];
        return;
      }
      // console.log(this.detailList[i]);
      if (this.detailList[i]?.drug?.id && this.detailList[i]?.drug?.id !== drug.id) {
        this.detailList[i].toDelete = true;
      }
      this.detailList.push({drug: {...drug}, qty: 1, income_price: 0, cost_price: 0});
      if (!this.costPriceData[drug.id]) {
        this.getCostPrice(drug);
      }
      this.addEmptyRow();
    },
  }
}

</script>

<style scoped>
.moderate_qty {
  width: 150px;
}

.moderate_qty.input-group input {
  width: 55px;
}
</style>

<style>

.sorting_block .dropdown-menu.show {
  background-color: white;
}

.sorting_block .dropdown-menu.show a {
  color: #212529;
  text-decoration: none;
  text-transform: none;
}

.totalSumBlock p {
  margin-bottom: 0;
}
</style>

<style scoped>
table.table tr.no_en_title {
  background-color: #fdfdb1;
}

table.table tr.storeMissing {
  background-color: #ffcfcf;
}

table.table td {
  vertical-align: top;
}

table.table p.table_p {
  margin-top: 10px;
}

.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5BBFDE;
  margin: -3px 4px;
  mask: url(/assets/svg/snowflake-solid.svg);
}

table.table td {
  padding: 3px;
}

table.table th {
  white-space: normal;
  padding: 3px 8px;
  font-size: 12px;
}

table.table input {
  width: 90px;
}

.totalSumBlock {
  text-align: right;
  padding: 5px;
  background-color: #007dcc;
  position: sticky;
  top: 0;
  z-index: 8;
  //font-weight: 700; color: white;
}

.sticky_tr {
  position: sticky;
  top: 34px;
  z-index: 3;
  background-color: white;
  box-shadow: 1px 4px 5px -1px #c8c8c8;
}

table.table input.w_50p {
  width: 50px;
}
</style>
